var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor"},[_c('apexchart',{ref:"demoChart",attrs:{"type":"line","height":"350","options":_vm.chartOptions,"series":this.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }